import { GlobalPriceType } from "../enums";

export class GlobalPriceChartRequest {
    id:number;
    component: string;
    price: number;
    type:GlobalPriceType
    createdAt: Date;
    createdUser:string;
    updatedAt: Date;
    updatedUser:string;
    constructor(
        id:number,
        component:string,
        price: number,
        type:GlobalPriceType,
        createdAt?: Date,
        createdUser?:string,
        updatedAt?: Date,
        updatedUser?:string, 
        ){
        this.id = id
        this.component = component
        this.price = price
        this.createdUser = createdUser
        this.updatedUser = updatedUser
        this.createdAt = createdAt
        this.updatedAt = updatedAt
        this.type = type
    }
}